import styled from 'styled-components'

export const CourtContainer = styled.div`
  display: flex;
`

export const CourtItemContainer = styled.div`
  margin-left: 19px;
`
export const CourtCount = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 25px;
`

export const CourtContentContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`

export const CourtPrice = styled.span`
  color: ${({ theme }) => theme.colors.third};
  margin-left: 15px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
`

export const CourtTitle = styled.h1`
  margin: 0;
  color: #1a1a1a;
  font-weight: 500;
  font-size: 28px;
`
